'use client';

import React, { useState } from 'react';
import { AppDateTimePicker } from '../../customComponents/AppDateTimePicker';
import styled from 'styled-components';
import { AppColors } from '../../styles/colors';

const Container = styled.div`
  padding: 40px;
  max-width: 600px;
  margin: 0 auto;
  background-color: ${AppColors.input};
  min-height: 100vh;
`;

const Section = styled.div`
  margin-bottom: 40px;
  padding: 20px;
  background-color: white;
  border-radius: 12px;
  border: 1px solid ${AppColors.onInput1};
`;

const Title = styled.h2`
  color: ${AppColors.onInput3};
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
`;

const SubTitle = styled.h3`
  color: ${AppColors.onInput2};
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 500;
`;

const ValueDisplay = styled.div`
  margin-top: 12px;
  padding: 12px;
  background-color: ${AppColors.input};
  border-radius: 8px;
  color: ${AppColors.onInput3};
  font-size: 14px;
`;

const DateTimePickerTest: React.FC = () => {
  const [dateOnly, setDateOnly] = useState<Date | null>(null);
  const [dateTime, setDateTime] = useState<Date | null>(null);
  const [dateWithError, setDateWithError] = useState<Date | null>(null);
  const [readOnlyDate, setReadOnlyDate] = useState<Date | null>(new Date());

  return (
    <Container>
      <Title>AppDateTimePicker 테스트</Title>
      
      <Section>
        <SubTitle>1. 기본 날짜 선택 (날짜만)</SubTitle>
        <AppDateTimePicker
          value={dateOnly}
          onChange={setDateOnly}
          label="날짜 선택"
          placeholder="날짜를 선택하세요"
        />
        <ValueDisplay>
          선택된 값: {dateOnly ? dateOnly.toISOString() : '없음'}
        </ValueDisplay>
      </Section>

      <Section>
        <SubTitle>2. 날짜 + 시간 선택</SubTitle>
        <AppDateTimePicker
          value={dateTime}
          onChange={setDateTime}
          label="날짜 및 시간 선택"
          placeholder="날짜와 시간을 선택하세요"
          showTime={true}
        />
        <ValueDisplay>
          선택된 값: {dateTime ? dateTime.toISOString() : '없음'}
        </ValueDisplay>
      </Section>

      <Section>
        <SubTitle>3. 에러 상태</SubTitle>
        <AppDateTimePicker
          value={dateWithError}
          onChange={setDateWithError}
          label="날짜 선택"
          placeholder="날짜를 선택하세요"
          errorMessage="필수 입력 항목입니다"
        />
        <ValueDisplay>
          선택된 값: {dateWithError ? dateWithError.toISOString() : '없음'}
        </ValueDisplay>
      </Section>

      <Section>
        <SubTitle>4. 읽기 전용</SubTitle>
        <AppDateTimePicker
          value={readOnlyDate}
          onChange={setReadOnlyDate}
          label="읽기 전용 날짜"
          readOnly={true}
        />
        <ValueDisplay>
          선택된 값: {readOnlyDate ? readOnlyDate.toISOString() : '없음'}
        </ValueDisplay>
      </Section>

      <Section>
        <SubTitle>5. 날짜 범위 제한 (오늘부터 30일 후까지)</SubTitle>
        <AppDateTimePicker
          value={dateOnly}
          onChange={setDateOnly}
          label="제한된 날짜 선택"
          placeholder="오늘부터 30일 후까지만 선택 가능"
          minDate={new Date()}
          maxDate={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}
        />
        <ValueDisplay>
          선택된 값: {dateOnly ? dateOnly.toISOString() : '없음'}
        </ValueDisplay>
      </Section>

      <Section>
        <SubTitle>6. 커스텀 포맷</SubTitle>
        <AppDateTimePicker
          value={dateTime}
          onChange={setDateTime}
          label="커스텀 포맷"
          placeholder="MM/dd/yyyy HH:mm"
          showTime={true}
          dateFormat="MM/dd/yyyy HH:mm"
        />
        <ValueDisplay>
          선택된 값: {dateTime ? dateTime.toISOString() : '없음'}
        </ValueDisplay>
      </Section>
    </Container>
  );
};

export default DateTimePickerTest;
